<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/AiMKr9/cover.jpeg?1684245186276" alt="This image is the cover for the book Mature Man's Sweet Love, Volume 1"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Mature Man's Sweet Love, Volume 1
      </h1>
      <p class="bookDescription body article font2">
        <p><strong>Su Fan, who had just entered the workplace, was sent to the room of an old man by his superior. Su Fan, who had just entered the workplace, was sent to the room of an old man. What to do? This man had both power and power. The key was his looks and height. How was this an uncle?</strong> </p><p>It was even stronger than fresh meat! Many years later, he would press her, who was wearing a gorgeous wedding dress, into the fitting room. The cold glass pierced her bones, and next to his ears, he could hear his charming voice, "Little darling, you have to pay back the debts you owe me slowly!" Heavens, did she even need a small body like this?</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Mu WanXi, Lemon Novel
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Funstory
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?1248f87a